/**
 * 'YYYY-MM' from LOCAL date parts. `toISOString().slice(0, 7)` is UTC and would
 * put a SAST user into the previous month for the first two hours of every
 * month — the same trap `dateTimeLocal.ts` documents for datetime-local values.
 */
export function currentMonthKey(now: Date = new Date()): string {
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}
